import { render } from "./BookFavorite.vue?vue&type=template&id=36cf0466&scoped=true"
import script from "./BookFavorite.vue?vue&type=script&lang=js"
export * from "./BookFavorite.vue?vue&type=script&lang=js"

import "./BookFavorite.vue?vue&type=style&index=0&id=36cf0466&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-36cf0466"

export default script